import styles from "./iconactive.module.css";

 
type Ticonlink = {
  homeone: string;
  hometwo: string;
  rad: number;
  action: boolean;
};

export const IconActive = (props: Ticonlink) => {
  let bgone = props.homeone;
  let bgtwo = props.hometwo;

  const backgraundihomeone = {
    backgroundImage: `url(${bgone})`,
    width: `${props.rad}px`,
    height: `${props.rad}px`,
    borderRadius: `${props.rad}px`,
  };

  const backgraundihometwo = {
    backgroundImage: `url(${bgtwo})`,
    width: `${props.rad}px`,
    height: `${props.rad}px`,
    borderRadius: `${props.rad}px`,
  };

  return (
    <div
      className={styles.action}
      style={{
        width: `${props.rad}px`,
        height: `${props.rad}px`,
        borderRadius: `${props.rad}px`,
      }}
    >
      <div
        className={styles.icon}
        style={props.action ? backgraundihometwo : backgraundihomeone}
      ></div>
    </div>
  );
};
export default IconActive;
